import { render, staticRenderFns } from "./InventoryFormModal.vue?vue&type=template&id=6f94d312&"
import script from "./InventoryFormModal.vue?vue&type=script&lang=js&"
export * from "./InventoryFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports